module.exports = __webpack_public_path__ + "img/the-netherlands-transport-accidents-female.f51497a5.png";